import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let ShareControls = class ShareControls extends Vue {
    onClosed() {
        this.$emit('share-closed');
    }
    getShareUrl() {
        var host = window.location.protocol + "//" + window.location.host;
        return `${host}/car-park-finder?id=${this.selectedMarkerId}`;
    }
    get webSocialShareConfig() {
        let url = this.getShareUrl();
        return {
            displayNames: true,
            config: [{
                    copy: {
                        socialShareUrl: url
                    }
                },
                {
                    email: {
                        socialShareBody: `${url}\r\n\r\n`,
                        socialShareSubject: 'Park Mark Accredited Parking',
                    }
                },
                {
                    facebook: {
                        socialShareUrl: url,
                        socialSharePopupWidth: 400,
                        socialSharePopupHeight: 400 //has loads of options - but not sure they do anything
                    }
                },
                {
                    linkedin: {
                        socialShareUrl: url //socialShareDescription?: string; //socialShareSource?: string;
                    }
                },
                {
                    twitter: {
                        socialShareUrl: url,
                        socialSharePopupWidth: 300,
                        socialSharePopupHeight: 400,
                        socialShareText: `Park Mark Accredited Parking : `,
                        socialShareHashtags: `ParkMark,saferparking` //socialShareVia?: string; 
                    }
                },
                {
                    whatsapp: {
                        socialShareUrl: url,
                        socialShareText: 'Park Mark Accredited Parking',
                    }
                }]
        };
    }
};
tslib_1.__decorate([
    Prop()
], ShareControls.prototype, "shown", void 0);
tslib_1.__decorate([
    Prop()
], ShareControls.prototype, "selectedMarkerId", void 0);
ShareControls = tslib_1.__decorate([
    Component
], ShareControls);
export default ShareControls;
